{
  "pt": {
    "employee": {
      "actions": {
        "accessProjects": "Gerir o acesso aos projetos",
        "cancel": "Anular",
        "changeProfilePicture": "Alterar a imagem do perfil",
        "download": "Descarregar",
        "new": "Membro da equipa",
        "profilePictureFormat": "Deve ter pelo menos 300x300px",
        "save": "Guardar",
        "searchEmployee": "Membro da equipa de pesquisa",
        "sendinvitation": "Criar e enviar o convite",
        "submit": "Guardar",
        "undoChanges": "Anular"
      },
      "attributes": {
        "email_address": "E-mail",
        "email_notifications_interval": {
          "daily": "Uma vez por dia (por volta do meio-dia)",
          "hourly": "Cada hora",
          "twice_daily": "Duas vezes por dia (manhã/tarde)",
          "weekly": "Uma vez por semana (segunda-feira ao meio-dia)"
        },
        "first_name": "Nome próprio",
        "language": "Língua",
        "last_name": "Apelido",
        "phone_landline": "Número de telefone fixo",
        "phone_mobile": "Número de telemóvel",
        "profession": "Título do emprego",
        "role": "Direitos de acesso",
        "signature_html": "Assinatura de conversa",
        "status": "Estado",
        "title": "Título"
      },
      "billing": {
        "contact_us": "Contacte-nos",
        "contact_us_message": "Olá, gostaria de alterar o pacote de {client_name}.",
        "gigabytes": "{amount} GB",
        "in_use": "/ {total} em uso",
        "manage_members": "Gerir membros",
        "package": "Pacote",
        "package_help_mup": "Procura projetos ou armazenamento extra, ou quer mudar de plano?",
        "package_help_sup": "Procura projetos, lugares ou armazenamento extra, ou quer mudar de plano?",
        "plan_renamed": "Introduzimos novos planos, por isso o nome apresentado aqui pode não corresponder à sua subscrição atual. Contacte-nos para saber mais sobre os novos planos.",
        "projects": "Projetos",
        "projects_available": "Todos os projetos em uso | 1 projeto disponível | {count} projetos disponíveis",
        "seats": "Lugares",
        "seats_active": "/ {total} ativos",
        "seats_package": "Nenhum lugar no seu pacote | 1 lugar no seu pacote | {count} lugares no seu pacote",
        "seats_paying": "+ 1 lugar extra pago | + {count} lugares extra pagos",
        "storage": "Armazenamento",
        "storage_available": "{amount} GB disponíveis",
        "storage_total": "/ {amount} GB",
        "units": "Unidades",
        "units_available": "Todas as unidades em uso | 1 unidade disponível | {count} unidades disponíveis"
      },
      "integrations": {
        "hide_details": "Ocultar detalhes",
        "last_synced_at": "Última sincronização: {time}",
        "show_details": "Mostrar detalhes"
      },
      "labels": {
        "all_projects": "Todos os projetos",
        "confirmPasswordReset": "Foi enviado um e-mail com uma ligação para redefinir a sua palavra-passe. Contacte-nos se tiver algum problema.",
        "disabled": {
          "access": "Concederemos a todos os funcionários acesso à plataforma a partir do momento em que a sua subscrição for reativada.",
          "contact": "Contactar-nos",
          "overdue": "Verificámos que a sua última fatura está muito atrasada. Revogámos o acesso de todos os funcionários a esta plataforma. Os parceiros e clientes continuarão a poder aceder aos seus dados.",
          "title": "A sua conta foi desativada!"
        },
        "display": "Mostrar",
        "filters": "Filtros",
        "generalNotifications": "Notificar-me sobre",
        "has_access_to": "Tem acesso a",
        "information": "Informações sobre o perfil",
        "informationNotificationsEmail": "Receber um resumo por e-mail, incluindo apenas as notificações que ainda não viu na plataforma.",
        "informationNotificationsPlatform": "Receber todas as notificações na sua visão geral pessoal no canto superior direito do ecrã",
        "informationNotificationsTitle": "Decida que tipo de notificações pretende receber e como",
        "its_you!": "Próprio",
        "maintainerAccess": "Acesso concedido por projeto.",
        "name": "Nome",
        "onPlatform": "Na plataforma",
        "ownerAccess": "Acesso a todos os projetos e conteúdos, mais a faturação e a gestão da equipa.",
        "password": "Palavra-passe",
        "permissions": "Direitos de acesso para",
        "permissionsOwnerOnly": "Como Mantenedor do Projeto, não pode realizar esta ação. Peça a um membro da equipa {client_name} com o papel de Proprietário para fazer isto por si.",
        "projectMaintains": "{first_name} tem acesso aos seguintes projetos:",
        "projectMaintainsAdd": "Para conceder acesso, selecione um projeto e adicione {first_name} como um Mantenedor de projeto na funcionalidade Informações.",
        "projectMaintainsNone": "não tem acesso a nenhum projeto.",
        "projectNotifications": "Para o projeto",
        "search_by_name_or_email": "Pesquisar por nome ou e-mail",
        "show_signature": "Mostrar assinatura",
        "signature_active": "Assinatura ativa",
        "signature_info": "Esta assinatura será acrescentada às respostas enviadas aos clientes e parceiros.",
        "sorting": "Classificação",
        "viaEmail": "Por e-mail"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Acessível",
          "description": "As alterações são guardadas automaticamente",
          "not_accessible": "Não acessível",
          "title": "Atualizar acessibilidade do projeto para {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Mantenedor",
        "owner": "Proprietário"
      },
      "team": {
        "actions": {
          "activate": "Ativar",
          "cancel_invitation": "Cancelar convite",
          "deactivate": "Desativar",
          "invite": "Convidar",
          "make_maintainer": "Tornar mantenedor",
          "make_owner": "Tornar proprietário",
          "remove": "Remover da equipa"
        },
        "dialogs": {
          "activate_body": "{name} volta a ter acesso total à plataforma.",
          "activate_body_pending": "{name} volta a Pendente e fica ativo quando iniciar sessão com o convite.",
          "activate_body_seat": "{name} volta a ter acesso total à plataforma. Isto usa um lugar.",
          "activate_confirm": "Ativar",
          "activate_title": "Ativar {name}?",
          "cancel_invitation_body": "{name} deixa de poder juntar-se com o convite recebido.",
          "cancel_invitation_confirm": "Cancelar convite",
          "cancel_invitation_title": "Cancelar o convite?",
          "contact_us": "Contacte-nos",
          "contact_us_message": "Olá, gostaria de adicionar mais lugares para {client_name}.",
          "deactivate_body": "{name} mantém a conta mas perde o acesso à plataforma.",
          "deactivate_body_seat": "{name} mantém a conta mas perde o acesso à plataforma. Isto liberta um lugar.",
          "deactivate_confirm": "Desativar",
          "deactivate_title": "Desativar {name}?",
          "demote_body": "{name} perde o acesso a todos os projetos até que lho atribua, e deixa de poder gerir a faturação e a equipa.",
          "demote_confirm": "Tornar mantenedor",
          "demote_title": "Tornar {name} mantenedor?",
          "owner_wall_banner": "A sua organização tem de ter sempre pelo menos um proprietário ativo.",
          "owner_wall_body_deactivate": "Reative ou promova outro proprietário antes de desativar {name}.",
          "owner_wall_body_demote": "Reative ou promova outro proprietário antes de mudar a função de {name}.",
          "owner_wall_body_remove": "Reative ou promova outro proprietário antes de remover {name}.",
          "owner_wall_title": "Ação bloqueada",
          "promote_body": "{name} passa a ter acesso a todos os projetos e pode gerir a faturação e a equipa.",
          "promote_confirm": "Tornar proprietário",
          "promote_title": "Tornar {name} proprietário?",
          "remove_body": "{name} perde o acesso e sai da lista de membros. Não é possível anular, mas pode voltar a convidar mais tarde.",
          "remove_body_seat": "{name} perde o acesso e sai da lista de membros. Não é possível anular, mas pode voltar a convidar mais tarde. Isto liberta um lugar.",
          "remove_confirm": "Remover",
          "remove_title": "Remover {name} da equipa?",
          "seats_full_banner": "O seu único lugar está em uso. | Todos os {total} lugares estão em uso.",
          "seats_full_body": "Desative um membro ativo para libertar um lugar, ou contacte-nos para adicionar mais lugares.",
          "seats_full_invite_body": "Precisa de um lugar disponível para convidar alguém. Desative um membro ativo, ou contacte-nos para adicionar mais lugares.",
          "seats_full_invite_title": "Ficou sem lugares",
          "seats_full_title": "Não há lugares disponíveis"
        },
        "invite_incomplete": "Preencha o nome, o apelido e o e-mail para enviar o convite.",
        "invite_note": "Ficam ativos assim que criam uma conta e iniciam sessão.",
        "invite_note_seats": "Assim que criarem uma conta e iniciarem sessão, ficam ativos e usam o seu último lugar disponível. | Assim que criarem uma conta e iniciarem sessão, ficam ativos e usam um dos seus {count} lugares disponíveis.",
        "invite_sent": "Convite enviado",
        "invited_at": "Convidado: {when}",
        "last_active": "Última atividade",
        "manage_in_billing": "Gerir em Faturação",
        "resend_wait": "Pode reenviar o convite 15 minutos depois do anterior.",
        "role": "Função",
        "seat_states": "Estados dos lugares",
        "seat_states_help": {
          "active": "Acesso total, usa um lugar. Proprietários e mantenedores.",
          "inactive": "A conta existe, sem acesso à plataforma. Liberta o lugar.",
          "pending": "Convidado, ainda sem conta. Não usa lugar."
        },
        "seat_usage": "Utilização de lugares",
        "seats_available": "Não há lugares disponíveis - desative um membro ou contacte-nos | 1 lugar disponível | {count} lugares disponíveis",
        "seats_rule": "Só um proprietário pode ativar um membro, e só enquanto houver um lugar disponível.",
        "seats_total": "/ {total} lugar ativo | / {total} lugares ativos",
        "statuses": {
          "active": "Ativo",
          "inactive": "Inativo",
          "pending": "Pendente"
        }
      },
      "toasts": {
        "create": "Foi criado um membro da equipa",
        "update": "O membro da equipa foi atualizado"
      },
      "validation": {
        "emailTaken": "O endereço de e-mail já foi utilizado",
        "mustBeEmailAddress": "É necessário um endereço de e-mail válido",
        "needFirstName": "Nome próprio obrigatório",
        "needLastName": "Apelido obrigatório",
        "requireEmailAddress": "E-mail necessário",
        "role": "Selecionar direitos de acesso"
      }
    }
  }
}
